import { queryAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { urlToPattern } from "../urlToPattern";
import logo from "./logo.svg";

export const shelly = defineConnector({
  identifier: "shelly",
  name: "Shelly",
  tagLine: "Cloud control for Shelly smart home devices",
  logo,
  protocol: "http",
  tags: ["productivity", "it"],
  defaultUrlPattern: ({ serverUrl }) =>
    urlToPattern(serverUrl || "https://shelly-1-eu.shelly.cloud"),
  auth: (app) => queryAuth([{ name: "auth_key", value: app.secret.authKey }]),
  steps: [
    {
      title: "Get your cloud authorization key",
      items: [
        {
          kind: "markdown",
          content:
            "In the Shelly app, open User settings → Authorization cloud key. Enable the key, then copy both the authorization key and the server address shown on that page. Note that the key changes if you change your account password.",
        },
      ],
    },
    {
      title: "Enter your Shelly cloud details",
      items: [
        {
          kind: "baseUrl",
          label: "Server address",
          placeholder: "https://shelly-1-eu.shelly.cloud",
          required: true,
          helperText: "The server address shown alongside your cloud key.",
          target: { kind: "configuration", field: "serverUrl" },
        },
        {
          kind: "input",
          label: "Authorization cloud key",
          required: true,
          target: { kind: "secrets", field: "authKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ serverUrl }) => ({
      url: new URL(
        "/device/all_status?show_info=true&no_shared=true",
        serverUrl || "https://shelly-1-eu.shelly.cloud"
      ).toString(),
      method: "POST",
      expectedStatus: 200,
    }),
  },
});
